import {Route} from '@angular/router';
import {VehicleDatabaseComponent} from './vehicle-database/vehicle-database.component';
import {ReportsComponent} from './reports/reports.component';
import {TrackVehicleComponent} from './track-vehicle/track-vehicle.component';
import {ProfileComponent} from './profile/profile.component';
import {AddVehicleComponent} from './add-vehicle/add-vehicle.component';
import {BulkUploadComponent} from './vehicle-database/bulk-upload/bulk-upload.component';
import {LoginComponent} from './auth/login/login.component';
import {LayoutComponent} from './layout/layout.component';
import {ForgotPasswordComponent} from './auth/forgotPassword/forgot-password/forgot-password.component';
import {ChangePasswordComponent} from './auth/change-password/change-password.component';
import {AuthGuardService} from './services/authGuard.service';
import {EditVehicleDatabaseComponent} from './edit-vehicle-database/edit-vehicle-database.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {
    ForgotPasswordConfimComponent
} from './auth/forgotPassword/forgot-password-confim/forgot-password-confim.component';
import {
    ForgotPasswordRedirectComponent
} from './auth/forgotPassword/forgot-password-redirect/forgot-password-redirect.component';
import {BlackListedVehicleComponent} from './black-listed-vehicles/black-listed-vehicle/black-listed-vehicle.component';
import {SignupComponent} from './auth/signup/signup.component';
import {NavHeaderComponent} from './publicPage/nav-header/nav-header.component';
import {
    AddBlackListedVehicleComponent
} from './black-listed-vehicles/add-black-listed-vehicle/add-black-listed-vehicle.component';
import {OrganizationComponent} from './admin/organization/organization.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AddOrganizationComponent} from './admin/add-organization/add-organization.component';
import {EditOrganizationComponent} from './admin/edit-organization/edit-organization.component';
import {EventsComponent} from './events/events.component';
import {ServiceHealthStatusComponent} from './service-health-status/service-health-status.component';
import {HotListedVehicleComponent} from './hotListedVehicle/hot-listed-vehicle/hot-listed-vehicle.component';
import {AddHotListedVehicleComponent} from './hotListedVehicle/add-hot-listed-vehicle/add-hot-listed-vehicle.component';
import {AddCamerasComponent} from './cameraPage/add-cameras/add-cameras.component';
import {ViewCamerasComponent} from './cameraPage/view-cameras/view-cameras.component';
import {EditCameraComponent} from './cameraPage/edit-camera/edit-camera.component';
import {ViewBridgesComponent} from './bridgePage/view-bridges/view-bridges.component';
import {AddBridgeComponent} from './bridgePage/add-bridge/add-bridge.component';
import {EditBridgeComponent} from './bridgePage/edit-bridge/edit-bridge.component';
import {VerifyMobileNumberComponent} from './verify-mobile-number/verify-mobile-number.component';
import {AnalyticsComponent} from './analytics/analytics.component';
import {AlertComponent} from './alert/alert.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {LogsComponent} from './logs/logs.component';
import {LoginActivityComponent} from './login-activity/login-activity.component';
import {SubscriptionsComponent} from './subscriptions/subscription/subscriptions.component';
import {SubscriptionFormComponent} from './subscriptions/subscription-form/subscription-form.component';
import {SubscriptionDetailComponent} from './subscriptions/subscription-detail/subscription-detail.component';
import {SuperUserGuardService} from './services/superUserGuard.service';
import {LeadManagementGuardService} from './services/leadManagementGuard.service';
import {SubscriptionAccessGuardService} from './services/subscriptionAccessGuard.service';
import {MemberMutationGuardService} from './services/memberMutationGuard.service';
import {VisitorManagementAdminGuardService} from './services/visitorManagementAdminGuard.service';
import {PartnersComponent} from './admin/partners/partners.component';
import {PartnerFormComponent} from './admin/partners/partner-form.component';
import {ApiKeysComponent} from './admin/api-keys/api-keys.component';
import {ContactUsRequestsComponent} from './admin/contact-us-requests/contact-us-requests.component';
import {RegisterListComponent} from './visitor-management/register-engine/register-list/register-list.component';
import {RegisterFormComponent} from './visitor-management/register-engine/register-form/register-form.component';
import {FieldConfigComponent} from './visitor-management/register-engine/field-config/field-config.component';
import {ClusterComponent} from './visitor-management/register-engine/cluster/cluster.component';
import {ClusterFormComponent} from './visitor-management/register-engine/cluster-form/cluster-form.component';
import {EntryListComponent} from './visitor-management/register-engine/entry-list/entry-list.component';
import {SelectRegisterComponent} from './visitor-management/register-engine/select-register/select-register.component';
import {EntryFormComponent} from './visitor-management/register-engine/entry-form/entry-form.component';
import {RoleLandingComponent} from './role-landing.component';
import {LeadDashboardComponent} from './lead-management/lead-dashboard/lead-dashboard.component';
import {LeadListComponent} from './lead-management/lead-list/lead-list.component';
import {LeadFormComponent} from './lead-management/lead-form/lead-form.component';
import {LeadDetailComponent} from './lead-management/lead-detail/lead-detail.component';
import {FollowUpListComponent} from './lead-management/follow-up-list/follow-up-list.component';
import {DemoScheduleComponent} from './lead-management/demo-schedule/demo-schedule.component';
import {
    SalesInstallationPartnersComponent
} from './admin/sales-installation-partners/sales-installation-partners.component';
import {
    SalesInstallationPartnerFormComponent
} from './admin/sales-installation-partners/sales-installation-partner-form.component';
import {
    SalesInstallationPartnerDetailComponent
} from './admin/sales-installation-partners/sales-installation-partner-detail.component';
import {InitialOccupancyUploadComponent} from './admin/initial-occupancy-upload/initial-occupancy-upload.component';
import {VehicleMonitoringComponent} from './vehicle-monitoring/vehicle-monitoring.component';
import {EditVehicleMonitoringComponent} from './vehicle-monitoring/edit-vehicle-monitoring/edit-vehicle-monitoring.component';

export const routes: Route[] = [
   
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent},
    { path: 'reset-password', component: ForgotPasswordRedirectComponent },
    { path: 'forgot-password-confirm', component: ForgotPasswordConfimComponent},
    { path: 'verify-mobile-otp', component: VerifyMobileNumberComponent, canActivate: [AuthGuardService] },

   
    // { path: '', redirectTo: 'login', pathMatch: "full"},
    
    { path: '', 
        component: LayoutComponent,
        canActivate: [AuthGuardService],
        children:[
        
           
            { path: 'vehicle', component: VehicleDatabaseComponent },
            { path: 'reports', component: ReportsComponent },
            { path: 'track', component: TrackVehicleComponent },
            { path: 'profile', component: ProfileComponent },
            {path: 'add-vehicle', component: AddVehicleComponent, canActivate: [MemberMutationGuardService]},
            { path: "profile/edit/:pk", component: ProfileComponent },
            {path: "vehicle/bulk", component: BulkUploadComponent, canActivate: [MemberMutationGuardService]},
            { path: 'change-password', component: ChangePasswordComponent},
            {
                path: 'get-vehicle/:pk',
                component: EditVehicleDatabaseComponent,
                canActivate: [MemberMutationGuardService]
            },
            {
                path: 'edit-vehicle/:pk',
                component: EditVehicleDatabaseComponent,
                canActivate: [MemberMutationGuardService]
            },
            { path: 'contact-us', component: ContactUsComponent},
            { path: 'blacked-vehicle', component: BlackListedVehicleComponent},
            {
                path: 'add-vehicle-black-list',
                component: AddBlackListedVehicleComponent,
                canActivate: [MemberMutationGuardService]
            },
            // { path: 'staff', component: StaffComponent},
            { path: 'organization', component: OrganizationComponent},
            {path: 'signup', component: SignupComponent, canActivate: [MemberMutationGuardService]},
            { path: 'dashboard', component: DashboardComponent},
            {path: 'organization/add', component: AddOrganizationComponent, canActivate: [MemberMutationGuardService]},
            {
                path: 'organization/edit/:pk',
                component: EditOrganizationComponent,
                canActivate: [MemberMutationGuardService]
            },
            {
                path: 'organization/edit',
                component: EditOrganizationComponent,
                canActivate: [MemberMutationGuardService]
            },
            { path: 'events', component: EventsComponent},
            {
                path: 'service-health-status',
                component: ServiceHealthStatusComponent,
                canActivate: [SuperUserGuardService]
            },
            { path: 'view-hotlist', component: HotListedVehicleComponent},
            {path: 'add-hotlist', component: AddHotListedVehicleComponent, canActivate: [MemberMutationGuardService]},
            { path: 'vehicle-monitoring', component: VehicleMonitoringComponent},
            { path: 'vehicle-alert-rules', redirectTo: 'vehicle-monitoring', pathMatch: 'full'},
            {
                path: 'add-vehicle-monitoring',
                component: EditVehicleMonitoringComponent,
                canActivate: [MemberMutationGuardService]
            },
            {
                path: 'add-vehicle-alert',
                redirectTo: 'add-vehicle-monitoring',
                pathMatch: 'full',
            },
            {
                path: 'edit-vehicle-monitoring/:id',
                component: EditVehicleMonitoringComponent,
                canActivate: [MemberMutationGuardService]
            },
            {
                path: 'edit-vehicle-alert/:pk',
                component: EditVehicleMonitoringComponent,
                canActivate: [MemberMutationGuardService]
            },
            {path: 'add-camera', component: AddCamerasComponent, canActivate: [MemberMutationGuardService]},
            { path: 'view-cameras', component: ViewCamerasComponent},
            {path: 'edit-camera/:pk', component: EditCameraComponent, canActivate: [MemberMutationGuardService]},
            {
                path: 'view-bridges',
                component: ViewBridgesComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            {path: 'add-bridge', component: AddBridgeComponent, canActivate: [AuthGuardService, SuperUserGuardService]},
            {
                path: 'edit-bridge/:pk',
                component: EditBridgeComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            { path: 'analytics', component: AnalyticsComponent },
            { path: 'alert', component: AlertComponent },
            {path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService]},
            { path: 'logs', component: LogsComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'login-activity', component: LoginActivityComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'subscriptions', component: SubscriptionsComponent, canActivate: [AuthGuardService, SubscriptionAccessGuardService] },
            { path: 'subscriptions/new', component: SubscriptionFormComponent, canActivate: [AuthGuardService, SubscriptionAccessGuardService] },
            { path: 'subscriptions/:id/edit', component: SubscriptionFormComponent, canActivate: [AuthGuardService, SubscriptionAccessGuardService] },
            { path: 'subscriptions/:id', component: SubscriptionDetailComponent, canActivate: [AuthGuardService, SubscriptionAccessGuardService] },
            { path: 'admin/partners', component: PartnersComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'admin/partners/new', component: PartnerFormComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'admin/partners/:id/edit', component: PartnerFormComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            { path: 'admin/api-keys', component: ApiKeysComponent, canActivate: [AuthGuardService, SuperUserGuardService] },
            {
                path: 'admin/contact-us-requests',
                component: ContactUsRequestsComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            {
                path: 'admin/initial-occupancy-upload',
                component: InitialOccupancyUploadComponent,
                canActivate: [AuthGuardService, SuperUserGuardService]
            },
            { path: 'admin/sales-installation-partners', component: SalesInstallationPartnersComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'admin/sales-installation-partners/new', component: SalesInstallationPartnerFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'admin/sales-installation-partners/:id/edit', component: SalesInstallationPartnerFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'admin/sales-installation-partners/:id', component: SalesInstallationPartnerDetailComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/dashboard', component: LeadDashboardComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads', component: LeadListComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads/new', component: LeadFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads/:id/edit', component: LeadFormComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/leads/:id', component: LeadDetailComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/follow-ups', component: FollowUpListComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            { path: 'lead-management/demo-schedule', component: DemoScheduleComponent, canActivate: [AuthGuardService, LeadManagementGuardService] },
            {
                path: 'visitor-management/registers',
                component: RegisterListComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/registers/create',
                component: RegisterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/registers/:id/edit',
                component: RegisterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/registers/:id/fields',
                component: FieldConfigComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/clusters',
                component: ClusterComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/clusters/create',
                component: ClusterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/clusters/:id/edit',
                component: ClusterFormComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            {
                path: 'visitor-management/entries',
                component: EntryListComponent,
                canActivate: [VisitorManagementAdminGuardService]
            },
            { path: 'visitor-management/select-register', component: SelectRegisterComponent },
            { path: 'visitor-management/entry/:id/edit', component: EntryFormComponent },
            { path: 'visitor-management/entry/:registerId', component: EntryFormComponent },
            
            { path: '', component: RoleLandingComponent, pathMatch: "full"}


        ]
    },
    { path: '',
        component:NavHeaderComponent,
        children:[
            
            
        ]
    },
    { path: "**", redirectTo: ""}
    
    
        
    
];
